import React from 'react';
import { withCookies } from 'react-cookie';
import AuthContext from './AuthContext';
import get from 'lodash.get';
const AuthProvider = function AuthProvider(props) {
    const token = get(props, 'cookies.cookies.authToken');
    const [loggedIn, setLoggedIn] = React.useState(!!token);
    const value = React.useMemo(() => ({ loggedIn, updateLoggedIn: setLoggedIn }), [loggedIn]);
    return React.createElement(AuthContext.Provider, Object.assign({ value: value }, props));
};
export default withCookies(AuthProvider);
//# sourceMappingURL=AuthProvider.js.map